module.exports = 10



// WEBPACK FOOTER //
// ./app/scripts/data/sticker-margin.coffee